import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "./ui/card";
import { Button } from "./ui/button";
import { useTranslation } from "react-i18next";
import { ChevronLeftCircle, LockIcon } from "lucide-react";

export default function RouteDenied() {
  const { t } = useTranslation();

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <Card className="shadow-none border-none place-content-center h-full">
      <CardHeader>
        <CardTitle className="justify-center items-center text-5xl flex flex-col gap-4">
          <LockIcon size={64} />
          {t("pageDenied.title")}
        </CardTitle>
      </CardHeader>
      <CardContent className="my-4">
        <p className="text-center text-2xl w-3/4 mx-auto">
          {t("pageDenied.description")}
        </p>
      </CardContent>
      <CardFooter className="justify-center">
        <Button onClick={handleGoBack}>
          <ChevronLeftCircle size={16} className="mr-3" />
          {t("pageDenied.backButton")}
        </Button>
      </CardFooter>
    </Card>
  );
}
